import { useStrings } from "@1js/localization-components";
import { Text, makeStyles } from "@fluentui/react-components";
import * as React from "react";
import type { LinkedPrompt } from "../../services/prompt-client.web";
import { ManageAccessDialogInstructions } from "./ManageSharedPrompts.strings";
import { NoSharedPrompts } from "./NoSharedPrompts";
import { SharedPromptsContentSkeleton } from "./SharedPromptsContentSkeleton.web";
import { SharedPromptsList } from "./SharedPromptsList.web";

const useStyles = makeStyles({
  textWrapper: {
    display: "flex",
    alignItems: "flex-start",
    paddingBottom: "12px",
    flexDirection: "column",
    gap: "8px",
    alignSelf: "stretch",
  },
  text: {
    fontFamily: "Segoe UI",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "20px",
  },
  footer: {
    position: "absolute",
    height: "400px",
    bottom: "0px",
    background:
      "linear-gradient(0deg, #FFF 83.37%, rgba(255, 255, 255, 0.00) 98.72%)",
  },
});

type SharedPromptsContentProps = {
  isLoading: boolean;
  onDeletePrompt(prompt: LinkedPrompt): void;
  prompts: LinkedPrompt[];
};

export const SharedPromptsContent: React.FC<SharedPromptsContentProps> = ({
  isLoading,
  onDeletePrompt,
  prompts,
}) => {
  const strings = useStrings({
    ManageAccessDialogInstructions,
  });
  const styles = useStyles();
  if (isLoading) {
    return <SharedPromptsContentSkeleton />;
  }

  return prompts.length === 0 ? (
    <NoSharedPrompts />
  ) : (
    <div>
      <div className={styles.textWrapper} data-testid="dialog-list-title">
        <Text className={styles.text}>
          {strings.ManageAccessDialogInstructions()}
        </Text>
      </div>
      <SharedPromptsList prompts={prompts} onDeletePrompt={onDeletePrompt} />
    </div>
  );
};
